<template>
  <div class="brains-tabs-container">
    <div class="brains-tabs-row-container">
      <div v-if="additionalBtnPresented" class="additional-btn-container">
        <slot name="additionalBtn" />
      </div>
      <div class="brains-tabs--all-container">
        <div v-if="overflow" :class="{ 'brains-tabs--overflow__left-hidden' : counter === 0 }" class="brains-tabs--overflow brains-tabs--overflow__left">
          <em class="el-icon-arrow-left" @click="scrollLeft()" />
        </div>
        <div :id="brainsTabsId" class="brains-tabs">
          <div v-for="(tab, index) in tabsordered" :key="index" class="brains-tabs--tab" :class="{ 'is-active': tab.isActive }">
            <div @click="selectTab(tab)">{{ tab.name }}</div>
          </div>
        </div>
        <div v-if="overflow" :class="{ 'brains-tabs--overflow__right-hidden' : rightScrollHidden }" class="brains-tabs--overflow brains-tabs--overflow__right">
          <em class="el-icon-arrow-right" @click="scrollRight()" />
        </div>
      </div>
    </div>

    <div class="brains-tabs-details">
      <slot />
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
export default {
  name: 'BrainsTabs',
  props: {
    useorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabs: [],
      randomNum: 0,
      scrollWidth: null,
      clientWidth: null,
      // Se establece un intervalo que ejecuta una función cada segundo hasta que el scroll este visible para poder saber si hay overflow o no
      sizeInterval: setInterval(this.initTabs, 1000),
      counter: 0,
      rightScrollHidden: false
    }
  },
  computed: {
    brainsTabsId() {
      return 'brains-tabs-' + this.randomNum
    },
    overflow() {
      if (this.clientWidth < this.scrollWidth) {
        return true
      } else {
        return false
      }
    },
    additionalBtnPresented() {
      return this.$slots.additionalBtn !== null && this.$slots.additionalBtn !== undefined
    },
    tabsordered() {
      if (this.useorder) {
        return _.sortBy(this.tabs, 'ordernumber')
      }
      return this.tabs
    }
  },
  watch: {
    scrollWidth(newOne, oldOne) {
      if (newOne > 0 && newOne !== null) {
        clearInterval(this.sizeInterval)
      }
    }
  },
  created() {
    this.generateRandomNum()
    this.tabs = this.$children
  },
  mounted() {
    setTimeout(() => {
      this.initTabs()
    }, 2000)
  },
  methods: {
    scrollRight() {
      document.getElementById(this.brainsTabsId).scrollBy(160, 0)
      setTimeout(() => {
        this.counter++
        if (this.clientWidth + document.getElementById(this.brainsTabsId).scrollLeft >= this.scrollWidth) {
          this.rightScrollHidden = true
        }
      }, 350)
    },
    scrollLeft() {
      document.getElementById(this.brainsTabsId).scrollBy(-160, 0)
      setTimeout(() => {
        this.counter--
        if (this.clientWidth + document.getElementById(this.brainsTabsId).scrollLeft <= this.scrollWidth) {
          this.rightScrollHidden = false
        }
      }, 350)
    },
    initTabs() {
      var item = document.getElementById(this.brainsTabsId)
      if (item !== null && item !== undefined) {
        this.scrollWidth = item.scrollWidth
        this.clientWidth = item.clientWidth
      }
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    selectTab(selectedTab) {
      this.$emit('selectedTab', selectedTab.name)
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name === selectedTab.name
      })
    },
    unselectall() {
      this.tabs.forEach((tab) => {
        tab.isActive = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.brains-tabs-container {
  width: 100%;
  // border-bottom: 1px solid #c0c4cc;
  // overflow: hidden;
  height: 100%;

  .brains-tabs-row-container {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #c0c4cc;

    .additional-btn-container {
      padding-left: 15px;
      padding-right: 10px;
    }

    .brains-tabs--all-container {
      display: flex;
      align-items: center;
      width: auto;
      overflow: hidden;

      .brains-tabs {
        overflow-x: hidden;
        display: flex;
        justify-content: flex-start;
        scroll-behavior: smooth;
        gap: 30px;
        padding: 12px 20px 10px 20px;
        width: 92%;
        align-items: center;

        &--tab {
          font-weight: 600;
          cursor: pointer;
          font-size: 16px;
          white-space: nowrap;

          &:hover {
            color: $primary-brains;
          }
        }

        &--overflow {
          width: 4%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &__left-hidden {
            i {
              display: none;
            }
          }

          &__right-hidden {
            i {
              display: none;
            }
          }
        }

        .is-active {
          color: $primary-brains;
        }
      }

    }
  }

  .brains-tabs-details {

    .brains-tabs-details--tab {
      height: calc(100vh - 142px);
      width: 100%;
      // overflow-y: auto;
      // max-height: 86vh;
    }
  }
}
</style>
